import { Component, Input, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdService, ServedAd } from '@app/services/ad.service';

@Component({
  selector: 'app-ad-strip',
  standalone: true,
  imports: [CommonModule],
  template: `
    @if (ad) {
      @if (ad.imageUrl) {
        <!-- Full-width strip image (~460x87.5, 5.25:1) -->
        <div class="ad-strip ad-strip--image" (click)="onClick()">
          <img class="ad-strip-img" [src]="ad.imageUrl" [alt]="ad.headline">
          <span class="ad-strip-badge ad-strip-badge--overlay">Sponsored</span>
        </div>
      } @else {
        <!-- Fallback: letter tile + text when no strip image was uploaded -->
        <div class="ad-strip" (click)="onClick()">
          <div class="ad-strip-icon">{{ (ad.headline || 'Ad')[0] }}</div>
          <div class="ad-strip-text">
            <span class="ad-strip-headline">{{ ad.headline }}</span>
            <span class="ad-strip-desc">{{ ad.description || ad.displayUrl }}</span>
          </div>
          <span class="ad-strip-badge">Sponsored</span>
        </div>
      }
    }
  `,
  styles: [`
    .ad-strip {
      display: flex;
      align-items: center;
      gap: 10px;
      padding: 10px 16px;
      background: #f0f7ff;
      border-bottom: 1px solid #dbeafe;
      cursor: pointer;
      transition: background 0.15s;
    }
    .ad-strip:hover { background: #e0efff; }

    /* Full-width image strip (~460x87.5, 5.25:1) */
    .ad-strip--image { display: block; padding: 0; position: relative; }
    .ad-strip-img { width: 100%; aspect-ratio: 460 / 87.5; object-fit: cover; display: block; }
    .ad-strip-badge--overlay {
      position: absolute; top: 6px; right: 8px;
      background: rgba(255, 255, 255, 0.85); padding: 1px 6px; border-radius: 4px;
    }

    .ad-strip-icon {
      width: 36px; height: 36px; border-radius: 6px;
      background: #1565C0; color: white;
      display: flex; align-items: center; justify-content: center;
      font-size: 14px; font-weight: 600; flex-shrink: 0;
      overflow: hidden;
    }
    .ad-strip-icon img { width: 100%; height: 100%; object-fit: cover; }

    .ad-strip-text { flex: 1; min-width: 0; }
    .ad-strip-headline { display: block; font-size: 13px; font-weight: 500; color: #1a1a1a; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
    .ad-strip-desc { display: block; font-size: 11px; color: #6b7280; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }

    .ad-strip-badge {
      font-size: 9px; color: #9ca3af; text-transform: uppercase;
      letter-spacing: 0.05em; font-weight: 500; flex-shrink: 0;
    }
  `]
})
export class AdStripComponent implements OnInit {
  @Input() placement = '';
  private adService = inject(AdService);
  ad: ServedAd | null = null;

  ngOnInit() {
    this.adService.getAd(this.placement).subscribe(ad => this.ad = ad);
  }

  onClick() {
    if (this.ad) this.adService.recordClick(this.ad);
  }
}
